/* eslint-disable import/prefer-default-export */

import uuidv4 from 'uuid/v4';
import pRetry, { AbortError } from 'p-retry';

const EMPTY_JSON = '{}';

class ApiError extends Error {
  constructor(message, internalError) {
    super(message);
    this.internalError = internalError;
  }
}

const checkIfResponseError = (response) => response.status < 200 || response.status >= 300;

const handleResponse = (response) => {
  const responseError = checkIfResponseError(response);

  return responseError
    ? response.text()
    : response.status !== 204
      ? response.json()
      : EMPTY_JSON;
};

const handleResponseData = (data) => {
  let response = null;
  const errorMessage = 'Something went wrong';
  if (data) {
    try {
      response = JSON.parse(`${data}`);
    } catch (e) {
      response = data;
    }
    const responseError = checkIfResponseError(response);

    if (responseError) {
      throw new ApiError(response.message, response.internalError);
    }
  } else {
    throw errorMessage;
  }

  return response;
};

const handleError = (errorMessage) => {
  if ((errorMessage instanceof Error) && errorMessage.internalError) {
    // eslint-disable-next-line no-throw-literal
    throw {
      id: uuidv4(),
      message: errorMessage.message,
      internalError: errorMessage.internalError,
    };
  }

  let message = errorMessage;

  if (typeof errorMessage === 'object') {
    message = errorMessage.message;
  }

  // eslint-disable-next-line no-throw-literal
  throw {
    id: uuidv4(),
    message,
  };
};

const isUnrecoverableError = (status) => status === 401 || status === 403 || status === 404 || status === 500;

export const http = (URL, options = {}) => fetch(URL, options)
  .then(handleResponse)
  .then(handleResponseData)
  .catch(handleError);

export const httpWithRetry = async (URL, options = {}, retryOptions = {}) => pRetry(
  async () => {
    const response = await fetch(URL, options);

    if (isUnrecoverableError(response.status)) {
      throw new AbortError(response.statusText);
    }

    const content = await handleResponse(response);
    let parsedResponse = null;

    try {
      parsedResponse = handleResponseData(content);
    } catch (err) {
      handleError(err);
    }

    return parsedResponse;
  },
  retryOptions,
);



// WEBPACK FOOTER //
// ./api/fetch-wrapper.js